"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpIntervalPicker: {
        ariaLabel: 'Set timer to {{time}} minutes to finish the assessment',
    },
};
